














































































import { Component, Vue } from "vue-property-decorator";
import { BrokenRule } from "@/shared/models/apiErrors";
import { Token } from "@/shared/models/token";
import FormDescription from "@/components/misc/FormDescription.vue";

export class ResetPasswordModel {
  password = "";
  token = "";
}

@Component({
  components: { FormDescription },
})
export default class ResetPassword extends Vue {
  token?: Token;
  model = new ResetPasswordModel();

  expires = 0;
  email = "";

  repeatedPassword = "";
  showPassword1 = false;
  showPassword2 = false;

  showErrors = false;
  errors: string[] = [];

  isFormValid = false;
  isSubmitting = false;

  get submitDisabled(): boolean {
    return this.isFormValid && !this.isSubmitting;
  }

  get rules() {
    return {
      Required: (value: string) =>
        value ? true : this.$t("Validation.Required"),
      PasswordsMustMatch: (value: string, x: string) =>
        value === x ? true : this.$t("Validation.PasswordsMustMatch"),
    };
  }

  mounted() {
    const queryToken = this.$router.currentRoute.query["token"];
    if (typeof queryToken === "string") {
      this.token = new Token(queryToken);

      this.expires = this.token.exp;
      this.model.token = this.token.raw;
      this.email = this.token.values["email"];
    }
  }

  async send(): Promise<void> {
    this.isSubmitting = true;

    const resetPassword = await this.$store.dispatch(
      "auth/resetPassword",
      this.model
    );

    if (resetPassword.isSignedIn) {
      await this.$router.replace({ name: "Dashboard" });
    } else {
      this.errors = resetPassword.errors.map((x: BrokenRule) => x.name);
      this.showErrors = true;
    }

    this.isSubmitting = false;
  }

  get isExpired() {
    return this.expires < Date.now();
  }
}
